<template>
    <section class="bg-celebrate-green">
        <div class="container">
            <div class="row">
                <div :class="(successMessage === null ? 'col-lg-8' : 'col-lg-12') + ' celebrate-form order-1 order-lg-0'">
                    <div class="arrangement-form mb-4">
                        <h3>Reserveren</h3>
                        <div class="alert bg-success" v-if="successMessage !== null" id="form-validation" role="alert">
                            {{ successMessage }}
                        </div>
                        <form method="post" class="form" @submit.prevent="submitForm" v-if="successMessage === null">
                            <div class="row">
                                <div class="form-group col-lg-6">
                                    <label for="name">Naam</label>
                                    <input type="text" :class="'form-control' + (validationErrors.hasOwnProperty('name') ? ' is-invalid' : '')" id="name" name="name" v-model="form.name">
                                    <div class="invalid-feedback" v-if="validationErrors.hasOwnProperty('name')">
                                        {{ capitalizeFirstLetter(validationErrors['name'][0]) }}
                                    </div>
                                </div>
                                <div class="form-group col-lg-6">
                                    <label for="email">E-mailadres</label>
                                    <input type="email" :class="'form-control' + (validationErrors.hasOwnProperty('email') ? ' is-invalid' : '')" id="email" name="email" v-model="form.email">
                                    <div class="invalid-feedback" v-if="validationErrors.hasOwnProperty('email')">
                                        {{ capitalizeFirstLetter(validationErrors['email'][0]) }}
                                    </div>
                                </div>
                                <div class="form-group col-lg-5">
                                    <label for="phone">Telefoonnummer</label>
                                    <input type="tel" :class="'form-control' + (validationErrors.hasOwnProperty('phone') ? ' is-invalid' : '')" id="phone" name="phone" v-model="form.phone">
                                    <div class="invalid-feedback" v-if="validationErrors.hasOwnProperty('phone')">
                                        {{ capitalizeFirstLetter(validationErrors['phone'][0]) }}
                                    </div>
                                </div>
                                <div class="form-group col-lg-7">
                                    <label for="date">Datum</label>
                                    <input type="date" :class="'form-control' + (validationErrors.hasOwnProperty('date') ? ' is-invalid' : '')" id="date" name="date" v-model="form.date" :min="dayjs().add(1, 'day').format('YYYY-MM-DD')">
                                    <div class="invalid-feedback" v-if="validationErrors.hasOwnProperty('date')">
                                        {{ capitalizeFirstLetter(validationErrors['date'][0]) }}
                                    </div>
                                </div>

                                <div class="form-group col-lg-4">
                                    <label for="amount_of_people">Aantal personen</label>
                                    <input type="number" :class="'form-control' + (validationErrors.hasOwnProperty('amount_of_people') ? ' is-invalid' : '')" id="amount_of_people" name="amount_of_people" min="0"
                                           v-model="form.amount_of_people">
                                    <div class="invalid-feedback" v-if="validationErrors.hasOwnProperty('amount_of_people')">
                                        {{ capitalizeFirstLetter(validationErrors['amount_of_people'][0]) }}
                                    </div>
                                </div>
                                <div class="form-group col-lg-4">
                                    <label for="enterTime">Tijd aanvang</label>
                                    <input type="time" :class="'form-control' + (validationErrors.hasOwnProperty('start_time') ? ' is-invalid' : '')" id="enterTime" name="enterTime" v-model="form.start_time" min="00:00"
                                           max="23:59"
                                           pattern="[0-2][0-9]:[0-5][0-9]">
                                    <div class="invalid-feedback" v-if="validationErrors.hasOwnProperty('start_time')">
                                        {{ capitalizeFirstLetter(validationErrors['start_time'][0]) }}
                                    </div>
                                </div>
                                <div class="form-group col-lg-4">
                                    <label for="leaveTime">Tijd vertrek</label>
                                    <input type="time" :class="'form-control' + (validationErrors.hasOwnProperty('end_time') ? ' is-invalid' : '')" id="leaveTime" name="leaveTime" v-model="form.end_time" min="00:00" max="23:59"
                                           pattern="[0-2][0-9]:[0-5][0-9]">
                                    <div class="invalid-feedback" v-if="validationErrors.hasOwnProperty('end_time')">
                                        {{ capitalizeFirstLetter(validationErrors['end_time'][0]) }}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="comments">Eventuele toevoeging</label>
                                <textarea :class="'form-control' + (validationErrors.hasOwnProperty('comments') ? ' is-invalid' : '')" id="comments" name="comments" rows="3" v-model="form.comments"></textarea>
                                <div class="invalid-feedback" v-if="validationErrors.hasOwnProperty('comments')">
                                    {{ capitalizeFirstLetter(validationErrors['comments'][0]) }}
                                </div>
                            </div>
                            <div class="d-flex justify-content-end mt-5">
                                <button type="submit" class="btn btn-primary m-0" :disabled="loading">
                                    <template v-if="loading">
                                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        <span class="sr-only">Loading...</span>
                                    </template>
                                    <template v-else>
                                        Reserveren <i class="fas fa-arrow-right"></i>
                                    </template>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="col-lg-4 order-0 order-lg-1 mb-5 mb-lg-0 order-1 order-lg-0" v-if="successMessage === null">
                    <div class="arragement-summary">
                        <h3>Jouw reservering</h3>
                        <h5 v-if="props.isArrangement">Arrangement</h5>
                        <h5 v-else>Zaal</h5>
                        <p class="chosen-arrangement">{{ props.item.title }}</p>
                        <template v-if="form.date !== null">
                            <h5>Datum</h5>
                            <p class="chosen-date">{{ dayjs(form.date).format('DD-MM-YYYY') }}</p>
                        </template>
                        <template v-if="form.amount_of_people !== null">
                            <h5>Aantal personen</h5>
                            <p class="chosen-amount">{{ form.amount_of_people }}</p>
                        </template>
                        <template v-if="form.start_time !== null">
                            <h5>Tijd aanvang</h5>
                            <p class="chosen-enter">{{ form.start_time }}</p>
                        </template>
                        <template v-if="form.end_time !== null">
                            <h5>Tijd vertrek</h5>
                            <p class="chosen-leave">{{ form.end_time }}</p>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
import {ref} from 'vue';
import dayjs from 'dayjs';
import axios from 'axios';

const props = defineProps({
    isArrangement: {
        type:     Boolean,
        required: true
    },
    item:          {
        type:     Object,
        required: true
    },
    recaptchaKey:  {
        type:     String,
        required: true
    }
});

const getEmptyForm = () => {
    return {
        name:             null,
        email:            null,
        phone:            null,
        date:             null,
        amount_of_people: null,
        start_time:       null,
        end_time:         null,
        comments:         null,
        recaptcha_token:  null,
        resource_id:      null
    }
}

const loading          = ref(false);
const form             = ref({
    ...getEmptyForm()
});
const validationErrors = ref([]);
const successMessage   = ref(null);

const submitForm = () => {
    grecaptcha.ready(function() {
        grecaptcha.execute(props.recaptchaKey, {action: 'submit'}).then(function(token) {

            loading.value = true;

            form.value.recaptcha_token = token;
            form.value.resource_id     = props.item.id;

            axios.post('/api/reserveren', form.value).then((response) => {
                successMessage.value = response.data.message;
                form.value           = getEmptyForm();
            }).catch((error) => {
                if(error.response.status === 422) {
                    validationErrors.value = error.response.data.errors;
                } else {
                    validationErrors.value = ['Er is iets misgegaan, probeer het later opnieuw.'];
                }
            }).finally(() => {
                loading.value = false;
            });
        });
    });
}

const capitalizeFirstLetter = (string) => {
    return string[0].toUpperCase() + string.slice(1);
}

</script>